export default "__VITE_ASSET__COY$8CVS__"